import React from 'react';

const SectionHeader = ({ title, description, action, actionText, onActionClick }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div>
        <h2 className="text-xl font-semibold text-text-primary">{title}</h2>
        {description && (
          <p className="text-text-secondary mt-1">{description}</p>
        )}
      </div>
      {action && (
        <button
          onClick={onActionClick}
          className="btn-secondary btn-sm whitespace-nowrap"
        >
          {actionText || 'Ver todo'}
        </button>
      )}
    </div>
  );
};

export default SectionHeader;


